/**
 * Centralized, typed access to tracker env ids. Vite only exposes `VITE_`-
 * prefixed vars to the client bundle. A blank id disables its tracker (see
 * each tracker's `isConfigured()`), mirroring the Sentry DSN pattern.
 *
 * Read through this object (never `import.meta.env` directly in trackers) so
 * env access is in one place and easy to stub in tests.
 */
export const trackerConfig = {
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID ?? "",
  metaPixelId: import.meta.env.VITE_META_PIXEL_ID ?? "",
};
